import { render, staticRenderFns } from "./DocumentsCategoriesDlg.vue?vue&type=template&id=89ae3728&scoped=true"
import script from "./DocumentsCategoriesDlg.ts?vue&type=script&lang=ts&external"
export * from "./DocumentsCategoriesDlg.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ae3728",
  null
  
)

export default component.exports